module.exports = __webpack_public_path__ + "img/RebateKey-Mobile-App-tablet.webp";